import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cancelled-cheque-dialog',
  templateUrl: './cancelled-cheque-dialog.component.html',
  styleUrls: ['./cancelled-cheque-dialog.component.scss']
})

export class CancelledChequeDialogComponent {
  @ViewChild('uploadFile') fileUploader!: ElementRef
  file: any;
  constructor(private dialogRef: MatDialogRef<CancelledChequeDialogComponent>, private http: HttpClient) {

  }
  closeDialog(isTrue: Boolean) {
    this.dialogRef.close(isTrue);
  }

  fileSelect(event: any) {
    let fileList: FileList = event.target.files;
    this.file = fileList[0];

  }

  removeFile() {
    this.fileUploader.nativeElement.value = '';
    this.file = null;
  }

  con() {
    let formData: FormData = new FormData();
    formData.append('uploadFile', this.file, this.file.name)
    formData.append('docType', 'customer-cheque')
    this.http.post(`${'apiurl'}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
      {
        next: (res) => { this.closeDialog(true) },
        error: (err) => { this.closeDialog(false) },
      }
    );
  }
}
